module.exports = require("live/components/forms/ui/UserTable/EncryptForm");